// Pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = () => {
    if (email === 'adminlts@gmail.com' && password === 'admin@123') {
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/');
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 flex-col px-4">
     

      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-sm">
         <h1 className="text-3xl font-extrabold text-primary mb-4 text-center">
        WELCOME MAHAL BOOKING
      </h1>
        <h2 className="text-2xl font-bold text-center mb-6 text-primary">Login</h2>

        <input
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        />

        <input
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 mb-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        />

        <button
          onClick={handleLogin}
          className="w-full bg-primary hover:bg-secondary text-white font-semibold py-2 px-4 rounded transition duration-300"
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default Login;
